"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Enums_1 = require("../Enums");
exports.default = {
    name: 'Acteur',
    props: {
        value: {
            type: Object
        },
        readonly: {
            type: Boolean,
        },
        isProprietaire: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            optionsTypePropriete: Object.keys(Enums_1.TypeDroitProprieteEnum).map(function (_) { return Enums_1.TypeDroitProprieteEnum[_]; }),
        };
    },
    methods: {
        onChangeTypePersonne: function () {
            //Personne Physique = 1
            if (this.value.TypePersonne == 1) {
                this.value.Denomination = null;
                this.value.Representant = null;
            }
            else {
                this.value.Nom = null;
                this.value.Prenom = null;
            }
        },
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/Acteur.vue
// module id = 234
// module chunks = 0